/* eslint-disable react/prop-types */
import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import ReactTelephoneInput from 'react-telephone-input'
import { withTranslation, Trans } from 'react-i18next'

import './ActionLeadModal.scss'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import defaultAvatar from '../../assets/images/mock/StockProfilePic.png'

class ActionLeadModal extends React.Component {
  componentDidMount() {
    if (!this.props.notesLoader) {
      this._scrollToBottom()
    }
  }
  componentDidUpdate() {
    if (!this.props.notesLoader) {
      this._scrollToBottom()
    }
  }

  // eslint-disable-next-line max-lines-per-function, complexity
  render() {
    const {
      lead,
      close,
      handleInputChange,
      handlePhoneChange,
      newStatus,
      newEmail,
      newPhone,
      newPhonePrefix,
      newFirstName,
      newLastName,
      handleArchive,
      notes,
      notesLoader,
      getPillColor,
      leadNote,
      handleLeadNoteSubmit,
      postClicked,
      saveChanges,
      userAvatar,
      userFullName,
      emailModalOpen,
      closeEmailModal,
      handleInviteClick,
      inviteSuccess,
      inviteError,
      sendEmailClicked,
      handleSendEmail,
      isAdmin,
      handleSendReminder,
      failedEmailValidation,
      t,
    } = this.props

    const leadFullName = [newFirstName, newLastName].filter(Boolean).join(' ')
    const invitedUser = lead.invited_user
    const canRemind = !!(lead.is_invited && invitedUser && invitedUser.email === newEmail)

    return (
      <div id='ActionLeadModal'>
        <i
          className='fa fa-times exit-button'
          onClick={close}
          aria-hidden='true'
        />

        <div className='lead-info-section d-flex flex-column'>
          <div className='d-flex'>
            <div className='header-left'>
              <div className='name-container'>
                <i className='fa fa-user' aria-hidden='true' />
                <p className='num-golfers'>{lead.num_golfers} </p>
                <div className='divider' />
                <input
                  type='text'
                  name='newFirstName'
                  value={newFirstName}
                  className='lead-name'
                  onChange={handleInputChange}
                  onBlur={saveChanges}
                  placeholder={t('leads.actionModal.addFirstNamePlaceholder')}
                  autoComplete='given-name'
                />
                <input
                  type='text'
                  name='newLastName'
                  value={newLastName}
                  className='lead-name'
                  onChange={handleInputChange}
                  onBlur={saveChanges}
                  placeholder={t('leads.actionModal.addLastNamePlaceholder')}
                  autoComplete='family-name'
                />
              </div>
              <div className='status-container'>
                <p className='subtitle'>
                  {moment(lead.created_at).format('L LTS')}
                </p>
                <div
                  className='select-wrapper'
                  style={{
                    background: getPillColor(newStatus),
                    border: `2px solid ${getPillColor(newStatus)}`,
                  }}
                >
                  <select
                    name='newStatus'
                    onChange={handleInputChange}
                    value={newStatus}
                    disabled={lead.status === 'added'}
                  >
                    <option disabled value='none'>
                      {t('leads.actionModal.statuses.none')}
                    </option>
                    <option disabled value='new'>
                      {t('leads.actionModal.statuses.new')}
                    </option>
                    <option value='attempted'>{t('leads.actionModal.statuses.attempted')}</option>
                    <option value='contacted'>{t('leads.actionModal.statuses.contacted')}</option>
                    <option value='invited'>{t('leads.actionModal.statuses.invited')}</option>
                    <option value='added' hidden>
                      {t('leads.actionModal.statuses.added')}
                    </option>
                    <option value='not interested'>{t('leads.actionModal.statuses.notInterested')}</option>
                    <option value='inaccurate info'>{t('leads.actionModal.statuses.inaccurateInfo')}</option>
                  </select>
                </div>
              </div>
              <div className='email-container'>
                <i className='fa fa-envelope-o' aria-hidden='true' />
                <input
                  type='text'
                  name='newEmail'
                  value={newEmail}
                  className='lead-email'
                  onChange={handleInputChange}
                  onBlur={saveChanges}
                  placeholder={t('leads.actionModal.addEmailPlaceholder')}
                  autoComplete='email'
                />
              </div>
              <div className='phone-container'>
                <i className='fa fa-phone' aria-hidden='true' />
                <ReactTelephoneInput
                  class='phone-number'
                  defaultCountry='us'
                  flags={null}
                  value={newPhone ? newPhonePrefix + newPhone : ''}
                  onChange={(telNumber, selectedCountry) => {
                    const dialCode = selectedCountry?.dialCode ?? ''

                    const countryCode = selectedCountry?.iso2?.toUpperCase() ?? ''
                    const phoneNumber = telNumber?.replace(`+${dialCode}`, '') ?? telNumber ?? ''
                    const phonePrefix = dialCode ? `+${dialCode}` : ''

                    const phoneData = { phone: phoneNumber, phonePrefix: phonePrefix, phonePrefixCountry: countryCode }
                    handlePhoneChange(phoneData)
                  }}
                  onBlur={saveChanges}
                  placeholder={t('leads.actionModal.addPhonePlaceholder')}
                  autoComplete='tel'
                  maxLength='15'
                />
              </div>
            </div>
            <div className='header-right'>
              <div className='lead-action-button-container'>
                <button
                  className={`lead-action-button archive-button ${
                    lead.is_archived ? 'inverted' : ''
                  }`}
                  onClick={handleArchive}
                >
                  <i className='fa fa-archive' aria-hidden='true' />{' '}
                  {lead.is_archived
                    ? t('leads.actionModal.archived')
                    : t('common.action.archive')}
                </button>
                {!isAdmin && (
                  <button
                    className={`lead-action-button send-email-button ${
                      lead.is_invited ? 'inverted' : ''
                    }`}
                    onClick={handleInviteClick}
                    disabled={lead.status === 'added'}
                  >
                    <i className='fa fa-envelope-o' aria-hidden='true' />{' '}
                    {lead.is_invited
                      ? t('leads.actionModal.invitedToCommunity')
                      : t('leads.actionModal.inviteToCommunity')}
                  </button>
                )}
              </div>
              <div className='interest-skill-container'>
                <div className='interest-container'>
                  <p className='info-title'>
                    {t('leads.actionModal.interestLabel', { count: lead.interests.length })}
                  </p>
                  {lead.interests.length > 0 ? (
                    <p className='info-list'>{lead.interests.join(', ')}</p>
                  ) : (
                    <p className='info-list'>{t('leads.actionModal.noneLabel')}</p>
                  )}
                </div>
                <div className='skill-container'>
                  <p className='info-title'>
                    {t('leads.actionModal.skillLevelLabel', { count: lead.skill_levels.length })}
                  </p>
                  {lead.skill_levels.length > 0 ? (
                    <p className='info-list'>{lead.skill_levels.join(', ')}</p>
                  ) : (
                    <p className='info-list'>{t('leads.actionModal.noneLabel')}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='header-bottom'>
            <p className='original-message-title'>{t('leads.actionModal.originalMessage')}</p>
            <p className='original-message'>{lead.note}</p>
          </div>
        </div>
        <div className='notes-area'>
          {notesLoader ? (
            <div className='notes-loader-container'>
              <Loader message={t('leads.actionModal.loadingNotes')} />
            </div>
          ) : (
            <div className='lead-notes-container'>
              {notes.length > 0 ? (
                notes.map(n => {
                  const isAction = n.content.indexOf('<action>') > -1 // checks if this was an auto-fired message on status change === these begin
                  // with <action>.
                  const isInvite = n.content.indexOf('<action-invite>') > -1 // set by LeadPage component if someone sends invite email
                  const isAccept = n.content.indexOf('<action-accept>') > -1 // set by API if someone goes through registration with this invitation
                  return (
                    <div className='note-card' key={n.id}>
                      <div className='d-flex'>
                        <div // uses the current user if the author isn't available - redux doesn't have it available right when the lead is posted
                        // and will be available when loaded from the API => the same for the name
                          className='author-icon'
                          style={{
                            backgroundImage: `url(${
                              n.author
                                ? n.author.avatar
                                  ? n.author.avatar.file_url
                                  : defaultAvatar
                                : userAvatar
                                  ? userAvatar.file_url
                                  : defaultAvatar
                            })`,
                          }}
                        />
                        <p className='author-name'>
                          {n.author
                            ? `${n.author.first_name} ${n.author.last_name}`
                            : userFullName}
                        </p>
                      </div>
                      <p className='note-date'>
                        {moment(n.created_at).format('L LTS')}
                      </p>
                      <p
                        className={`note-content ${
                          isAction
                            ? 'green'
                            : isInvite
                              ? 'dark'
                              : isAccept
                                ? '#ff6633'
                                : ''
                        }`}
                      >
                        {isAction
                          ? n.content.substring(8)
                          : isInvite || isAccept // just so happens that these both have a 15 substring value
                            ? n.content.substring(15)
                            : n.content}
                      </p>
                    </div>
                  )
                })
              ) : (
                <div className='notes-loader-container'>
                  <p>{t('leads.actionModal.noNotes')}</p>
                </div>
              )}
              <div ref={el => (this.messagesEnd = el)} />
              {/* empty div to use as an anchor point for the auto scroll to the bottom of the notes section */}
            </div>
          )}
        </div>
        <div className='bottom-input-area'>
          <form className='bottom-form d-flex' autoComplete='new-stuff'>
            <input type='hidden' value='something' autoComplete='none' />
            {/* hack to get the autocomplete to turn off on the actual input */}
            <input
              type='text'
              name='leadNote'
              onChange={handleInputChange}
              value={leadNote}
              className='lead-note-input'
              placeholder={t('leads.actionModal.addNotePlaceholder')}
              autoComplete='off'
            />
            <button
              type='submit'
              disabled={postClicked}
              className='lead-note-post-button'
              onClick={leadNote ? e => handleLeadNoteSubmit(e, lead.id) : e => e.preventDefault()}
            >
              {postClicked ? (
                <i className='fa fa-spinner fa-spin' aria-hidden='true' />
              ) : (
                t('leads.actionModal.post')
              )}
            </button>
          </form>
        </div>
        {emailModalOpen ? (
          <>
            <div className='grey-grey-out' aria-hidden='true' onClick={closeEmailModal} />
            <div className='submodal'>
              <i
                className='fa fa-times exit-button submodal-exit'
                onClick={closeEmailModal}
                aria-hidden='true'
              />
              {inviteSuccess ? (
                <div className='submodal-content'>
                  <i className='fa fa-check-circle' aria-hidden='true' />
                  <p className='success-title'>{t('leads.actionModal.successTitle')}</p>
                  <p className='success-note'>
                    {t('leads.actionModal.invitationSentNote', { name: leadFullName })}
                  </p>
                </div>
              ) : (
                <div className='submodal-content'>
                  <p className='name-confirm'>
                    {canRemind
                      ? t('leads.actionModal.remindName', { name: leadFullName })
                      : t('leads.actionModal.inviteName', { name: leadFullName })}
                  </p>
                  {lead.is_invited && invitedUser ? (
                    canRemind ? (
                      <p className='email-confirm'>
                        <Trans
                          i18nKey='leads.actionModal.sendReminderTo'
                          components={{ span: <span className='actual-email' /> }}
                          values={{ email: newEmail }}
                        />
                      </p>
                    ) : (
                      <p className='email-confirm'>
                        <Trans
                          i18nKey='leads.actionModal.emailChangedConfirm'
                          components={{ email: <span className='actual-email' /> }}
                          values={{
                            oldEmail: invitedUser.email,
                            newEmail,
                          }}
                        />
                      </p>
                    )
                  ) : (
                    <p className='email-confirm'>
                      <Trans
                        i18nKey='leads.actionModal.sendInviteTo'
                        components={{ span: <span className='actual-email' /> }}
                        values={{ email: newEmail }}
                      />
                    </p>
                  )}
                  {!!inviteError && (
                    <p className='email-confirm invite-error'>{inviteError}</p>
                  )}
                  <div className='submodal-button-container'>
                    <button
                      className='submodal-button cancel'
                      onClick={closeEmailModal}
                    >
                      {t('leads.actionModal.nahNotYet')}
                    </button>
                    <button
                      disabled={sendEmailClicked}
                      className={`submodal-button invite ${
                        failedEmailValidation ? 'fail' : ''
                      }`}
                      onClick={() => {
                        if (canRemind) {
                          handleSendReminder(invitedUser.id, lead.id)
                        } else {
                          handleSendEmail(
                            newFirstName,
                            newLastName,
                            newEmail,
                            lead.community_id,
                            lead.id
                          )
                        }
                      }}
                    >
                      {sendEmailClicked ? (
                        <i
                          className='fa fa-spinner fa-spin'
                          aria-hidden='true'
                        />
                      ) : failedEmailValidation ? (
                        t('leads.actionModal.invalidEmail')
                      ) : canRemind ? (
                        t('leads.actionModal.yeahSendReminder')
                      ) : (
                        t('leads.actionModal.yeahSendInvite')
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : null}
      </div>
    )
  }

  _scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: 'smooth' })
  }
}

ActionLeadModal.propTypes = {
  lead: PropTypes.shape({
    id: PropTypes.number,
    community_id: PropTypes.number,
    note: PropTypes.string,
    num_golfers: PropTypes.number,
    created_at: PropTypes.string,
    status: PropTypes.string,
    is_archived: PropTypes.bool,
    is_invited: PropTypes.bool,
    interests: PropTypes.array,
    skill_levels: PropTypes.array,
    invited_user: PropTypes.shape({
      id: PropTypes.number,
      email: PropTypes.string,
    }),
  }),
  notesLoader: PropTypes.bool,
  newFirstName: PropTypes.string,
  newLastName: PropTypes.string,
  newPhone: PropTypes.string,
  newPhonePrefix: PropTypes.string,
  newPhonePrefixCountry: PropTypes.string,
  newEmail: PropTypes.string,
  handleArchive: PropTypes.func,
  handleInputChange: PropTypes.func,
  handlePhoneChange: PropTypes.func,
  emailModalOpen: PropTypes.bool,
  userFullName: PropTypes.string,
  userAvatar: PropTypes.shape({
    file_url: PropTypes.string,
  }),
  postClicked: PropTypes.bool,
  handleLeadNoteSubmit: PropTypes.func,
  leadNote: PropTypes.string,
  getPillColor: PropTypes.func,
  failedEmailValidation: PropTypes.bool,
  isAdmin: PropTypes.bool,
  sendEmailClicked: PropTypes.bool,
  handleInviteClick: PropTypes.func,
  notes: PropTypes.array,
  newStatus: PropTypes.string,
  close: PropTypes.func,
  handleSendReminder: PropTypes.func,
  handleSendEmail: PropTypes.func,
  inviteSuccess: PropTypes.bool,
  inviteError: PropTypes.string,
  closeEmailModal: PropTypes.func,
  saveChanges: PropTypes.func,
}

export default withTranslation()(ActionLeadModal)
